/* ================================================== */
/* PROJECTS → zoom
/* ================================================== */

var biggestZoomText = 0;

$(document).ready(function() {

	// Set zoom width
	if ($('#zoom').length) {
		$(window).resize(function() {
			$('#zoom').width($(window).width() - $('aside').width() - 1);
		}).resize();
	}

	// Go to zoom view
	$('.projects-list__item--place > a, .icon__thumbs--full:not(.active)').click(function(e) {
		e.preventDefault();

		// Scroll to thumb zoom
		// if (lastWidth >= 768) {
			var indexAttr = $(this).attr('data-index'),
				gotoNum   = (typeof indexAttr !== typeof undefined && indexAttr !== false) ? $(this).attr('data-index') : 1;

			$('.bar .height, .icon__thumbs').removeClass('active');
			$('.icon__thumbs--full').addClass('active');

			// $('.projects-list__item--entry .poster img').height(lastHeight - 160);
			zoomHeight();

			$('#zoom .lazy-zoom').lazyload({
				container  : $('#zoom .scroll'),
				placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mPkFZFiBQAAswBC9ed+dwAAAABJRU5ErkJggg==',
				effectspeed: 0,
				threshold  : 400
			});

			$('#zoom .scroll').scrollTop($('#zoom-' + gotoNum).position().top);
			setTimeout(function(){ $('#zoom').addClass('visible') }, 100);
		// }
	});

	// Go back to list view
	$('.bar .height, .icon__thumbs--bigger, .icon__thumbs--smaller').on('click change', function() {
		if (!$(this).is('.active')) {
			$('#zoom').removeClass('visible');
			$('.bar .height, .icon__thumbs--bigger, .icon__thumbs--smaller').addClass('active');
			$('.icon__thumbs--full').removeClass('active');
			setTimeout(function(){ $('#zoom .scroll').scrollTop(0) }, 200);
		}
	});

	// Auto open zoom
	if (typeof AUTO_OPEN_ZOOM !== 'undefined' && AUTO_OPEN_ZOOM === true) {
		setTimeout(function(){
			$('.projects-list__item--place:eq(0) > a').click();
		}, 0); // keep 0 to fix triggerless
	}
});

function zoomHeight() {
	// Get biggest text height
	$('.projects-list__item--entry').each(function(index, element){
		var elHeight = $('.text', element).height();
		if (elHeight > biggestZoomText) biggestZoomText = elHeight;
	});

	// Set poster image max height
	var maxHeight = $('#zoom').height() - biggestZoomText - 60;
	$('.projects-list__item--entry .poster img').css('max-height', maxHeight);
}

$(window).resize(function() {
	zoomHeight();
});

document.addEventListener('webkitfullscreenchange', function() {
	zoomHeight();
}, false);

window.onorientationchange = function() {
	var orientation = window.orientation;
	zoomHeight();
}